import { useEffect, useState, useRef, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import classNames from "classnames";
import { useForm, Controller } from "react-hook-form";
import Icon from "../components/icons";
import CalendarSearch from "../components/calendar-search";
import Header from "../components/header";
import Breadcrumbs from "../components/breadcrumbs";
import EventCard from "../components/event-card";
import CustomSelect from "../components/custom-select";
import {
  FESTIVAL_DAYS,
  DISCIPLINE,
  TIPO_EVENTO,
  ID_CONFERENZA,
  target,
  ID_SPETTACOLO,
  ID_EVENTO_SPECIALE,
} from "../utils/constants";
import { placeholders } from "../utils/admin";
import {
  useRelatori,
  useLuoghi,
  useSearch,
  usePage,
  useFavourites,
  useToggleFavourite,
} from "../hooks/useQueryCustom";
import scaricaProgramma from "../assets/scarica-programma.jpg";
import PageContent from "../components/page-content";
import Seo from "../components/seo";
import { useNavigazione } from "../context/navigazione";
import UserContext from "../context/user";

const Programma = ({ page, breadcrumbs }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [favouriteFilter, setFavouriteFilter] = useState(
    searchParams.get("fav"),
  );
  const { programma: pdf } = useNavigazione();
  const { userProfile } = useContext(UserContext);

  const [advanceSearch, setAdvanceSearch] = useState(
    searchParams.get("idrelatore_r") ||
      searchParams.get("d_r") ||
      searchParams.get("t_r"),
  );
  const resultSection = useRef();
  const emptyValue = {
    d_r: "",
    dt_r: [],
    g_r: "",
    gratis_r: false,
    idrelatore_r: "",
    ml_r: "",
    t_r: "",
    tgr_r: [],
    order_r: "titolo",
  };

  const { data: relatori } = useRelatori();
  const { data: results } = useSearch(searchParams);
  const { data: luoghi } = useLuoghi();
  //console.log("luoghi", luoghi);

  const { data: favourite } = useFavourites();
  const toggleFavourite = useToggleFavourite();

  const {
    register,
    handleSubmit,
    watch,
    control,
    reset,
    setValue,
    // formState: { errors, isValid, isSubmitted, isSubmitSuccessful },
  } = useForm({
    defaultValues: async () => {
      let defaults = Object.fromEntries(searchParams);
      defaults.tgr_r = defaults.tgr_r?.split(",") || [];
      const dt_r = defaults.dt_r?.split(",") ?? emptyValue.dt_r ?? [];
      return { ...emptyValue, ...defaults, dt_r };
    },
  });
  const watchDay = watch("dt_r");
  const watchType = watch("g_r");
  const currentPage = searchParams.get("from");
  const currentdt_r = searchParams.get("dt_r")?.split(",") ?? [];

  const toggleFavouriteAction = async (id, value) => {
    try {
      if (toggleFavourite.isLoading) return;
      toggleFavourite.mutate({ id, favourite: value });
    } catch (err) {
      console.error("Error: ", err);
    }
  };

  const gotoPage = (page) => {
    console.log("gotoPage", page);
    const params = new URLSearchParams(searchParams);
    if (page > 0) {
      params.set("from", page * 12);
    } else {
      params.delete("from");
    }
    setSearchParams(params);
  };

  useEffect(() => {
    currentPage && resultSection.current.scrollIntoView();
  }, [currentPage]);

  /*   useEffect(() => {
    console.log("useEffect favouriteFilter");
    const params = new URLSearchParams();
    favouriteFilter && userProfile && params.set("fav", favouriteFilter);
    getValues("from") && params.set("from");
    setSearchParams(params);
  }, [favouriteFilter, userProfile, setSearchParams, getValues]); */

  const getFavourites = (value) => {
    console.log("getFavourite", value);
    const params = new URLSearchParams();
    setFavouriteFilter(value);
    if (value) {
      reset();
      params.set("fav", true);
      setSearchParams(params);
    } else {
      setSearchParams(params);
    }
  };

  useEffect(() => {
    if (
      watchType === ID_CONFERENZA ||
      watchType === ID_SPETTACOLO ||
      watchType === ID_EVENTO_SPECIALE
    ) {
      setValue("order_r", "data");
    } else {
      setValue("order_r", "titolo");
    }
  }, [watchType, setValue]);

  const dayRef = useRef(currentdt_r);
  useEffect(() => {
    if (
      watchDay?.length !== dayRef.current?.length ||
      watchDay?.some((d, i) => d !== dayRef.current?.[i])
    ) {
      dayRef.current = watchDay;
      const params = new URLSearchParams(searchParams);
      params.delete("from");
      if (watchDay?.length) {
        console.log("watchDay", watchDay, typeof watchDay);
        params.set("dt_r", watchDay.join(","));
      } else {
        params.delete("dt_r");
      }
      setSearchParams(params);
    }
  }, [watchDay, searchParams, setSearchParams]);

  const onSubmit = (variables) => {
    console.log("onSubmit");

    const params = new URLSearchParams();
    for (const key in variables) {
      variables[key] && params.set(key, variables[key]);
    }
    params.delete("fav");
    params.delete("from");
    setFavouriteFilter(false);
    setSearchParams(params);
  };

  const getMultiValue = (value, options) => {
    const values = value?.map((item) => options.find((i) => i.value === item));
    return values;
  };

  const { data } = usePage(page.link.slice(1));

  return (
    <>
      <Seo title={page.name} />
      <Header data={breadcrumbs} />
      {breadcrumbs && <Breadcrumbs data={breadcrumbs} />}
      <div role="main" className="main-wrapper  mt-3" id="main">
        <div className="container-md">
          <div className="row">
            <div className="col-12">
              {pdf && (
                <a
                  className="scarica-programma external"
                  title="Scarica il programma"
                  href={pdf}
                >
                  <img
                    className="scarica-programma__img"
                    alt="Scarica il programma"
                    src={scaricaProgramma}
                  />
                </a>
              )}
              <h1>{data?.titoloInPagina || data?.titolo}</h1>
              <PageContent data={data} />
              {/* <p>
                <Link title="Programma scuole" to="/programma-scuole">
                  <strong>
                    Per il pubblico scolastico, oltre al programma in presenza,
                    è disponibile anche un programma di eventi online.
                    Consultalo&nbsp;qui.
                  </strong>
                </Link>
              </p> */}
            </div>
          </div>
        </div>
        <form name="search-event" onSubmit={handleSubmit(onSubmit)}>
          <div className="container-md">
            <div className="row">
              <div className="col-12">
                <Controller
                  control={control}
                  name="dt_r"
                  render={({ field: { onChange, value } }) => (
                    <CalendarSearch
                      data={FESTIVAL_DAYS}
                      onChange={onChange}
                      value={value}
                    />
                  )}
                />
              </div>
            </div>
          </div>
          <div className="search-event py-4 mt-4">
            <div className="container-md">
              <fieldset>
                <div className="row">
                  <div className="col-12 col-xl-10 offset-xl-1">
                    <div className="d-flex flex-column flex-lg-row justify-content-between gap-4">
                      <div className="d-flex flex-column flex-grow-1">
                        <div className="d-flex flex-column flex-lg-row justify-content-between gap-4">
                          <input {...register("dt_r")} type="hidden" />
                          <input {...register("order_r")} type="hidden" />
                          <Controller
                            name="g_r"
                            control={control}
                            render={({
                              field: { onChange, value, ...other },
                            }) => (
                              <CustomSelect
                                placeholder="Tipo Evento"
                                className="search-event__select"
                                options={TIPO_EVENTO}
                                value={
                                  TIPO_EVENTO.find(
                                    (type) => type.value === value,
                                  ) || ""
                                }
                                onChange={(e) => {
                                  onChange(e?.value || "");
                                }}
                                isMulti={false}
                                {...other}
                              />
                            )}
                          />
                          <Controller
                            name="tgr_r"
                            control={control}
                            render={({
                              field: { onChange, value, ...other },
                            }) => (
                              <CustomSelect
                                placeholder="Età consigliata"
                                className="search-event__select"
                                options={target}
                                onChange={(e) => {
                                  onChange(
                                    Array.isArray(e)
                                      ? e.map((x) => x.value)
                                      : [],
                                  );
                                }}
                                value={getMultiValue(value, target)}
                                isMulti={true}
                                {...other}
                              />
                            )}
                          />
                          {luoghi && (
                            <Controller
                              name="ml_r"
                              control={control}
                              render={({
                                field: { onChange, value, ...other },
                              }) => (
                                <CustomSelect
                                  placeholder="Luogo"
                                  className="search-event__select"
                                  classNamePrefix="search-event__select"
                                  options={luoghi}
                                  onChange={(e) => {
                                    onChange(e?.value || "");
                                  }}
                                  value={
                                    luoghi.find(
                                      (item) => item.value === value,
                                    ) ||
                                    luoghi
                                      .map((item) => item.options)
                                      .filter(Boolean)
                                      .flat()
                                      .find((item) => item.value === value) ||
                                    ""
                                  }
                                  isMulti={false}
                                  {...other}
                                />
                              )}
                            />
                          )}
                        </div>

                        <div
                          className={classNames(
                            "search-event__advanced",
                            advanceSearch && "search-event__advanced--open",
                          )}
                        >
                          <div className="d-flex flex-column justify-content-between gap-2">
                            <div className="w-100 mt-4">
                              <input
                                className="search-event__input"
                                placeholder="Cerca nel titolo"
                                {...register("t_r", { required: false })}
                                type="text"
                              />
                            </div>
                            <div className="mt-4 d-flex flex-column flex-lg-row gap-4">
                              <Controller
                                name="d_r"
                                control={control}
                                render={({
                                  field: { onChange, value, ...other },
                                }) => (
                                  <CustomSelect
                                    placeholder="Disciplina"
                                    className="search-event__select"
                                    options={DISCIPLINE}
                                    onChange={(e) => {
                                      onChange(e?.value || "");
                                    }}
                                    value={
                                      DISCIPLINE.find(
                                        (type) => type.value === value,
                                      ) || ""
                                    }
                                    isMulti={false}
                                    {...other}
                                  />
                                )}
                              />
                              {relatori && (
                                <Controller
                                  name="idrelatore_r"
                                  control={control}
                                  render={({
                                    field: { onChange, value, ...other },
                                  }) => (
                                    <CustomSelect
                                      placeholder="Protagonisti"
                                      className="search-event__select"
                                      options={relatori}
                                      onChange={(e) => {
                                        onChange(e?.idrelatore || "");
                                      }}
                                      isMulti={false}
                                      getOptionLabel={(option) =>
                                        `${option.nome} ${option.cognome}`
                                      }
                                      value={
                                        relatori.find(
                                          (type) => type.idrelatore === value,
                                        ) || ""
                                      }
                                      getOptionValue={(option) =>
                                        option.idrelatore
                                      }
                                      {...other}
                                    />
                                  )}
                                />
                              )}
                            </div>
                            <div className="mt-4">
                              <input
                                className="search-event__checkbox"
                                value="1"
                                {...register("gratis_r")}
                                type="checkbox"
                              />
                              <label htmlFor="gratis_r">
                                Solo eventi gratuiti
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="w-100 text-end mt-4">
                          <button
                            className="search-event__btn me-4"
                            title="Azzera filtri"
                            type="reset"
                            onClick={() => {
                              reset(emptyValue);
                            }}
                          >
                            Azzera filtri
                            <Icon className="ms-2" name="xmark"></Icon>
                          </button>
                          <button
                            type="button"
                            className="search-event__btn"
                            title="Ricerca avanzata"
                            onClick={() => setAdvanceSearch(!advanceSearch)}
                          >
                            Ricerca avanzata
                            <Icon
                              className="ms-2"
                              name={advanceSearch ? "angle-up" : "angle-down"}
                            ></Icon>
                          </button>
                        </div>
                      </div>
                      <div>
                        <button className="search-event__submit" type="submit">
                          Cerca
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </form>
        <div ref={resultSection} />
        <div className="container-md">
          <div className="row">
            <div className="col-12">
              <div className="search-event__result-number my-4">
                <div>
                  {results?.nrows} risultati{" "}
                  {results?.current > 0 && ` - pagina ${results.current + 1}`}
                </div>
                {userProfile && (
                  <div>
                    <label
                      htmlFor="flexSwitchCheckDefault"
                      className="d-flex align-items-center"
                    >
                      <span className="toggle me-3">
                        <input
                          type="checkbox"
                          id="flexSwitchCheckDefault"
                          onChange={(e) => getFavourites(e.target.checked)}
                          checked={favouriteFilter}
                        />
                        <span className="toggle__slider" />
                      </span>
                      Preferiti
                    </label>
                  </div>
                )}
              </div>
              <div className="row">
                {(results?.rows || placeholders(6)).map((item, index) => (
                  <div key={index} className="col-sm-6 col-lg-4">
                    <EventCard
                      data={item}
                      enableFavourite={!!userProfile}
                      favourite={favourite?.events?.includes(item.id)}
                      toggleFavouriteAction={toggleFavouriteAction}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="search-event__pagination d-flex flex-wrap gap-2 justify-content-md-end">
                {(results?.npages?.length > 1 ||
                  (favouriteFilter === "true" && currentPage > 0)) &&
                  results?.npages?.map((item, index) => (
                    <button
                      className={classNames(
                        "",
                        results.current === index && "active",
                      )}
                      key={index}
                      onClick={() => gotoPage(index)}
                    >
                      {index + 1}
                    </button>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Programma;
